import "$styles/index.css"
import "$styles/syntax-highlighting.css"

import "$components/**/*.{js,jsx,js.rb,css}"

const MINUTE = 60
const MINUTES_IN_YEAR = 525_600

function railsDistanceInWords(seconds) {
  const minutes = Math.round(seconds / MINUTE)

  if (minutes <= 1) {
    if (seconds < 5) return "不到 5 秒前"
    if (seconds < 10) return "不到 10 秒前"
    if (seconds < 20) return "不到 20 秒前"
    if (seconds < 40) return "半分鐘前"
    if (seconds < 60) return "不到 1 分鐘前"
    return "1 分鐘前"
  }

  if (minutes < 45) return `${minutes} 分鐘前`
  if (minutes < 90) return "約 1 小時前"
  if (minutes < 1_440) return `約 ${Math.round(minutes / 60)} 小時前`
  if (minutes < 2_520) return "1 天前"
  if (minutes < 43_200) return `${Math.round(minutes / 1_440)} 天前`
  if (minutes < 86_400) return "約 1 個月前"
  if (minutes < MINUTES_IN_YEAR) return `${Math.round(minutes / 43_200)} 個月前`
  if (minutes < 1_051_200) return "約 1 年前"

  const years = Math.floor(minutes / MINUTES_IN_YEAR)
  const remainder = minutes % MINUTES_IN_YEAR
  if (remainder < 131_400) return `約 ${years} 年前`
  if (remainder < 394_200) return `超過 ${years} 年前`

  return `將近 ${years + 1} 年前`
}

function updateRelativeTimes() {
  document.querySelectorAll("time[data-relative-time]").forEach((time) => {
    const label = time.querySelector("[data-relative-time-label]")
    const timestamp = Date.parse(time.dateTime)
    if (!label || Number.isNaN(timestamp)) return

    const seconds = Math.max((Date.now() - timestamp) / 1_000, 0)
    label.textContent = railsDistanceInWords(seconds)
  })
}

updateRelativeTimes()
window.setInterval(updateRelativeTimes, 60_000)
